import axios from "axios";
import constant from "./constant";

const token = JSON.parse(localStorage.getItem("authUser"))?.token;
const id = JSON.parse(localStorage.getItem("authUser"))?.response?._id;
const creatorId = JSON.parse(localStorage.getItem("authUser"))?.response?._id;
const firmId =
  JSON.parse(localStorage.getItem("authUser"))?.response?.adminId ||
  JSON.parse(localStorage.getItem("authUser"))?.response?.firmId;
const Role = JSON.parse(localStorage.getItem("authUser"))?.response?.role;

const createAxiosInstance = axios.create({
  baseURL: `${constant.appBaseUrl}/api/`,
  headers: {
    "Content-Type": "multipart/form-data",
    Authorization: token ? `Bearer ${token}` : null,
  },
});

const axiosInstance = axios.create({
  baseURL: `${constant.appBaseUrl}/api/`,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = JSON.parse(localStorage.getItem("authUser"))?.token;
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  response=>response,
  error=>{
    if(error.response?.status===401){
      localStorage.removeItem("authUser");
      localStorage.removeItem("isLocked");
      if(window.location.pathname!=="/login"){
        window.location.replace("/login");
      }
      return Promise.reject(error);
    }
    return Promise.reject(
      error.response?.data || error
    );
  }
);

export const getDashboardAnalytics = async (id) => {
  try {
    const res = await axiosInstance.get(`/analytics/dashboard`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export default axiosInstance;